import { render, staticRenderFns } from "./return_list.vue?vue&type=template&id=b86c41ca&scoped=true"
import script from "./return_list.vue?vue&type=script&lang=js"
export * from "./return_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c41ca",
  null
  
)

export default component.exports